export const API_URL =
  window.location && window.location.hostname === "localhost"
    ? "http://localhost:3700"
    : "https://backend.aslcaptioning.com:3710";
